import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=682fa782&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=682fa782&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682fa782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682fa782')) {
      api.createRecord('682fa782', component.options)
    } else {
      api.reload('682fa782', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=682fa782&scoped=true", function () {
      api.rerender('682fa782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/menu.vue"
export default component.exports